// 状态对象

export default {
  langs: ["简体中文", "English", "日本語", "Español", "русский", "한국어"],
  langs_en: ["zh", "en", "ja", "es", "ru", "ko"],

  subscribeTag: 0,
  sseData: {}
};
